

import { Nullable, Point } from '@brg/api';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 */
export interface ComputedPoint {
    name: string;
    pointId: string;
    lon: number;
    lat: number;
    has: boolean;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param point
 */
export function computePoint(point: Nullable<Partial<Point>>): ComputedPoint {
    return {
        name: point?.name ?? 'unnamed',
        pointId: point?.pointId ?? 'undefined',
        lon: point?.longitude ?? 0,
        lat: point?.latitude ?? 0,
        has: !!point,
    };
}


import { Nullable, Point } from '@brg/api';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 */
export interface ComputedPoint {
    name: string;
    pointId: string;
    lon: number;
    lat: number;
    has: boolean;
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд
 * @param point
 */
export function computePoint(point: Nullable<Partial<Point>>): ComputedPoint {
    return {
        name: point?.name ?? 'unnamed',
        pointId: point?.pointId ?? 'undefined',
        lon: point?.longitude ?? 0,
        lat: point?.latitude ?? 0,
        has: !!point,
    };
}
